// test2256
(2256 && 0);
